import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FcpBadgeModule } from '../fcp-badge';
import { FcpIconModule } from '../fcp-icon';
import { FcpIconModuleSVG } from '../fcp-icon-svg';
import { FcpTabComponent } from './fcp-tab.component';

@NgModule({
    declarations: [FcpTabComponent],
    imports: [CommonModule, FcpIconModule, FcpBadgeModule, FcpIconModuleSVG],
    exports: [FcpTabComponent]
})
export class FcpTabModule {}
